import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import {
  DATA_ACCESS_TEXT_STYLE,
  DataAccessSectionHeading,
  DataAccessTabHeader,
  DataAccessText,
} from './dataAccessTypography';
import ClaudeMcpGuide from './ClaudeMcpGuide';
import CodexMcpGuide from './CodexMcpGuide';

type McpClientId = 'claude' | 'codex';

const MCP_CLIENTS: { id: McpClientId; label: string }[] = [
  { id: 'claude', label: 'Claude AI' },
  { id: 'codex', label: 'OpenAI Codex' },
];

const ConnectionMcpServer = () => {
  const [client, setClient] = useState<McpClientId>('claude');

  return (
    <div>
      <DataAccessTabHeader title="MCP Server">
        Connect Shiplab to AI tools that support the Model Context Protocol so you can ask questions
        about your connector groups, connectors, and invoices in plain language. Choose your client below
        and follow the matching setup steps.
      </DataAccessTabHeader>

      <DataAccessSectionHeading>How to connect</DataAccessSectionHeading>
      <DataAccessText className="text-700 mb-2">
        Setup differs slightly by client, but both Claude and Codex sign in with your Shiplab
        account. No API token is required for these flows.
      </DataAccessText>

      <div className="mb-4" style={{ maxWidth: '18rem' }}>
        <div className="text-900 fw-semi-bold mb-1" style={DATA_ACCESS_TEXT_STYLE}>
          Setup for
        </div>
        <Form.Select
          value={client}
          onChange={(e) => setClient(e.target.value as McpClientId)}
          aria-label="Setup for"
        >
          {MCP_CLIENTS.map((option) => (
            <option key={option.id} value={option.id}>
              {option.label}
            </option>
          ))}
        </Form.Select>
      </div>

      {client === 'claude' ? <ClaudeMcpGuide /> : <CodexMcpGuide />}
    </div>
  );
};

export default ConnectionMcpServer;
